import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import messg from 'messg'
import I18n from 'lib/i18n'

import Bugsnag from '~/scenes/bugsnag'

import profileLogic from './logic'

import controller from './controller.rb'

export default kea({
  connect: {
    actions: [profileLogic, ['translateReview', 'gotReviewTranslation']]
  },

  takeLatest: ({ actions, workers }) => ({
    [actions.translateReview]: workers.translateReview
  }),
  workers: {
    * translateReview (action) {
      const { gotReviewTranslation } = this.actions
      const { reviewId, locale } = action.payload

      try {
        const response = yield controller.translateReview({ id: reviewId, locale })

        if (response.error) {
          Bugsnag.notify('Kea error!', 'weird stuff', { caller: controller.index.toString() })
        } else {
          yield put(gotReviewTranslation(response.review))
        }
      } catch (error) {
        messg.error(`${I18n.t('profile.translation.error')}:(`, 2500)
        Bugsnag.notify(error)
      }
    }
  }
})
